import React from 'react';
import { findLink } from '../utilities/linkUtilities';
import { validateEmail } from '../../utilities/validateEmail';

const TextLink = (props) => {
    let url = props.decoratedText;
    const { schema } = findLink.match(url)[0];
    const urlTarget = url.includes(location.hostname) ? '' : '_blank';
    const mailto = 'mailto:';
    if (schema && (schema === mailto && !url.includes(mailto))) {
        url = mailto + url;
    } else if (!schema) {
        url = validateEmail(url) ? mailto + url : `http://${url}`;
    }

    return (
        <a href={url} target={urlTarget} rel="noopener noreferrer">
            { props.children }
        </a>
    );
};

export default TextLink;
